/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ClientFailureRecord interface.
 */
export function instanceOfClientFailureRecord(value) {
    if (!('app' in value) || value['app'] === undefined)
        return false;
    if (!('errorClass' in value) || value['errorClass'] === undefined)
        return false;
    if (!('page' in value) || value['page'] === undefined)
        return false;
    if (!('reportId' in value) || value['reportId'] === undefined)
        return false;
    return true;
}
export function ClientFailureRecordFromJSON(json) {
    return ClientFailureRecordFromJSONTyped(json, false);
}
export function ClientFailureRecordFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'app': json['app'],
        'build': json['build'] == null ? undefined : json['build'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'errorClass': json['error_class'],
        'page': json['page'],
        'reportId': json['report_id'],
    };
}
export function ClientFailureRecordToJSON(json) {
    return ClientFailureRecordToJSONTyped(json, false);
}
export function ClientFailureRecordToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'app': value['app'],
        'build': value['build'],
        'created_at': value['createdAt'] == null ? value['createdAt'] : value['createdAt'].toISOString(),
        'error_class': value['errorClass'],
        'page': value['page'],
        'report_id': value['reportId'],
    };
}
